import React, { useState } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { format } from "date-fns";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { saveAs } from "file-saver";
import ToPeso from "../components/misc/ToPeso";

// React Component
function DocumentDisclosureDiscountStatement({ applicantDetails, loanProcessingDetails }) {
    
    const [showModal, setShowModal] = useState(false);
    const [currentLoan, setCurrentLoan] = useState(null);
    const [formData, setFormData] = useState({
        clientsFund: "",
        otherCharges: "",
    });

  if (!applicantDetails) {
    return null;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    // Ensure all fields are filled
    if (Object.values(formData).some((value) => value.trim() === "")) {
      alert("All fields are required!");
      return;
    }

    // Close modal and generate PDF
    setShowModal(false);
    generatePDF(currentLoan, formData);
  };

  const openModal = (loan) => {
    setCurrentLoan(loan);
    setShowModal(true);
  };

  const generatePDF = async (loan, additionalFields) => {
    const existingPdfBytes = await fetch("/pdftemplates/disclosure-discount-statement.pdf").then(res =>
        res.arrayBuffer()
    );

    // Load PDF with pdf-lib
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Embed fonts
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    // Get the first page
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    // Fill the PDF with data
    firstPage.drawText(`${applicantDetails.firstName.toUpperCase()} ${applicantDetails.middleName.toUpperCase() || ""} ${applicantDetails.lastName.toUpperCase()}`, {
    x: 135,
    y: 657,
    size: 9,
    font: helveticaFont,
    color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${applicantDetails.street.toUpperCase()}, ${applicantDetails.barangay.toUpperCase()},`, {
        x: 135,
        y: 645,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${applicantDetails.municipality.toUpperCase()}, ${applicantDetails.province.toUpperCase()} ${applicantDetails.zipCode.toUpperCase()}`, {
        x: 37,
        y: 630,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${applicantDetails.employerDetails.toUpperCase()}`, {
        x: 135,
        y: 613,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${loan.loanTerm} ${loan.loanInterval.toUpperCase()}`, {
        x: 135,
        y: 600,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${loan.interestRate}%`, {
        x: 135,
        y: 587,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${loan.loanTerm}`, {
        x: 135,
        y: 562,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${format(new Date(loan.dateGranted), "MM/dd/yyyy")}`, {
        x: 135,
        y: 536,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${loan.amountGranted.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`, {
        x: 503,
        y: 657,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${((loan.amountGranted * (loan.interestRate / 100)) * loan.loanTerm).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`, {
        x: 503,
        y: 645,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    // Add additional fields from the popup form
    const { clientsFund, otherCharges } = additionalFields;
    const {serviceFee, insurance, docStamp, notarialFee} = loan;
    const additionalFieldsSum = (parseFloat(serviceFee) + parseFloat(insurance) + parseFloat(docStamp) + parseFloat(notarialFee) + parseFloat((loan.amountGranted * (loan.interestRate / 100))) + parseFloat(clientsFund) + parseFloat(otherCharges));
    const netProceeds = (loan.amountGranted - additionalFieldsSum);

    // Draw additional fields
    firstPage.drawText(`${parseFloat(serviceFee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
      x: 503,
      y: 614,
      size: 9,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${parseFloat(insurance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
      x: 503,
      y: 601,
      size: 9,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${parseFloat(docStamp).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
      x: 503,
      y: 588,
      size: 9,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${parseFloat(notarialFee).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
      x: 503,
      y: 576,
      size: 9,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${parseFloat((loan.amountGranted * (loan.interestRate / 100))).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
      x: 503,
      y: 563,
      size: 9,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${parseFloat(clientsFund).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
      x: 503,
      y: 536,
      size: 9,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`${parseFloat(otherCharges).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
      x: 503,
      y: 523,
      size: 9,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Total deductions
    firstPage.drawText(`${parseFloat(additionalFieldsSum).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
        x: 503,
        y: 497,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    // Net Proceeds Php
    firstPage.drawText(`${parseFloat(netProceeds).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
        x: 503,
        y: 485,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    // Acknowledgement
    firstPage.drawText(`${parseFloat(netProceeds).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, {
        x: 316,
        y: 436,
        size: 9,
        font: helveticaFont,
        color: rgb(0, 0, 0),
    });

    // Save the modified PDF
    const pdfBytes = await pdfDoc.save();

    // Use FileSaver to download the PDF
    saveAs(new Blob([pdfBytes]), `Disclosure_Discount_Statement_${applicantDetails.firstName.toUpperCase()}_${applicantDetails.lastName.toUpperCase()}_${loan.id}.pdf`);
  };

  return (
    <>
      <h3>Applicant Details</h3>
      <Table className="list-container" hover responsive>
        <tbody>
          <tr>
            <td><strong>Full Name</strong></td>
            <td>{`${applicantDetails.firstName} ${applicantDetails.middleName || ""} ${applicantDetails.lastName}`}</td>
          </tr>
          <tr>
            <td><strong>Address</strong></td>
            <td>{`${applicantDetails.street}, ${applicantDetails.barangay}, ${applicantDetails.municipality}, ${applicantDetails.province}`}</td>
          </tr>
        </tbody>
      </Table>
  
      <h3>Loan Processing Details</h3>
      {loanProcessingDetails.length > 0 ? (
        <Table className="list-container" hover responsive>
          <thead>
            <tr>
              <th>Type</th>
              <th>Amount Granted</th>
              <th>Date Granted</th>
              <th>Interest Rate</th>
              <th>Loan Term</th>
              <th>Payment Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loanProcessingDetails.map((loan, index) => (
              <tr key={index}>
                <td>{loan.loanProcessingType}</td>
                <td><ToPeso amount={loan.amountGranted.toFixed(2)} /></td>
                <td>{format(new Date(loan.dateGranted), "MM/dd/yyyy")}</td>
                <td>{loan.interestRate}%</td>
                <td>{loan.loanTerm} months</td>
                <td>{loan.paymentType}</td>
                <td>
                  <Button variant="primary" onClick={() => openModal(loan)}>
                    Generate Statement
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p>No loan processing details found for this applicant.</p>
      )}
  
      {/* Modal for additional fields */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Additional Fields</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Clients Fund</Form.Label>
              <Form.Control
                type="number"
                name="clientsFund"
                value={formData.clientsFund}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Other Charges</Form.Label>
              <Form.Control
                type="number"
                name="otherCharges"
                value={formData.otherCharges}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );  
}

export default DocumentDisclosureDiscountStatement;
